(function () {

  'use strict';

  angular.module('PrintixError', [])

    .constant('PrintixErrorConstants', {
      UNAUTHORIZED: 'unauthorized',
      FOUR_HUNDRED_FAMILY: 'fourHundredFamily',
      FIVE_HUNDRED_FAMILY: 'fiveHundredFamily'
    })

    .service('PrintixErrorService', function ($rootScope, $filter, PrintixErrorConstants, $ngBootbox) {

      const PrintixErrorServicePrivate = {};

      PrintixErrorServicePrivate.showErrorMessage = function (messageErrorObject) {
        $ngBootbox.customDialog({
          title: $filter('translate')('UpsSomethingWentWrong'),
          message: $filter('translate')(messageErrorObject.data.errorCode),
          buttons: {
            alert: {
              label: $filter('translate')('Close'),
              className: 'btn-danger',
              callback: function () {
                if (messageErrorObject.data.printixCallback) {
                  messageErrorObject.data.printixCallback();
                }
              }
            }
          }
        });
      };

      const deregisterFourHundredFamilyEventHandler = $rootScope.$on(PrintixErrorConstants.FOUR_HUNDRED_FAMILY, function (event, messageErrorObject) {
        PrintixErrorServicePrivate.showErrorMessage(messageErrorObject);
      });

      const deregisterFiveHundredFamilyEventHandler = $rootScope.$on(PrintixErrorConstants.FIVE_HUNDRED_FAMILY, function (event, messageErrorObject) {
        if (!messageErrorObject.data.errorCode) {
          messageErrorObject.data.errorCode = 'INTERNAL_SERVER_ERROR';
        }
        PrintixErrorServicePrivate.showErrorMessage(messageErrorObject);
      });

    })

    .factory('PrintixErrorProvider', function ($q, $rootScope, PrintixErrorConstants) {
      return {
        responseError: function (rejection) {
          const status = rejection.status;

          if (angular.isObject(rejection.data)) {
            rejection.data = rejection.data || {};
          } else {
            rejection.data = {
              message: rejection.data
            };
          }

          rejection.data.errorCode = rejection.data.errorCode || 'FrontEndRequestError';

          switch (true) {
            case status === 401:
            {
              $rootScope.$emit(PrintixErrorConstants.UNAUTHORIZED, rejection);
              break;
            }
            case status === 403:
            {
              rejection.data.errorCode = 'PERMISSION_DENIED';
              $rootScope.$emit(PrintixErrorConstants.FOUR_HUNDRED_FAMILY, rejection);
              break;
            }
            case status >= 400 && status <= 499:
            {
              // if (!rejection.config.url.startsWith('https://assets.')) {
              //   $rootScope.$emit(PrintixErrorConstants.FOUR_HUNDRED_FAMILY, rejection);
              // }
              break;
            }
            case status >= 500:
            {
              $rootScope.$emit(PrintixErrorConstants.FIVE_HUNDRED_FAMILY, rejection);
              break;
            }
          }

          return $q.reject(rejection);
        }
      };
    })

    .config(function ($httpProvider) {
      $httpProvider.interceptors.push('PrintixErrorProvider');
    });

})();
